/**
 * 此组件仅用来计算toolTip文字展示尺寸
 */
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { commonUtil } from '@qnpm/q-design-utils';
export default function FakeDayText(props) {
    const { data, computedStyle } = props;
    // 为空时，不渲染
    if (!data || !commonUtil.isValidArray(data)) {
        return null;
    }
    return (<View style={styles.wrapper}>
            {data.map((item, index) => (<View style={computedStyle.toolTip.wrapper} key={index} onLayout={(e) => {
        if (item.toolTip !== undefined) {
            const { width, height } = e.nativeEvent.layout;
            FakeDayText.prototype.contentSize[item.toolTip] = {
                width,
                height
            };
        }
    }}>
                    <Text style={[styles.text, computedStyle.toolTip.text]}>
                        {item.toolTip}
                    </Text>
                </View>))}
        </View>);
}
FakeDayText.prototype.contentSize = {};
const styles = StyleSheet.create({
    wrapper: {
        position: 'absolute',
        zIndex: -10
    },
    text: {
        color: 'rgba(0,0,0,0)'
    }
});
